import { Component, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploaderComponent } from "../../utility/file-uploader/file-uploader.component";
import { MessageService } from 'primeng/api';
import { ImageCropUploadComponent } from '../../utility/image-crop-upload/image-crop-upload.component';
import { AccountCentreService } from '../account-centre.service';
import { AuthService } from '../../services/account/auth.service';
import { Store } from '@ngxs/store';
import { UserStateModel } from '../../states/user/user-state-model';
import { UserResponse } from '../../models/account/userResponse';
import { UserSelectors } from '../../states/user/user-selector';
import { of, switchMap } from 'rxjs';
import { UpdateProfileCoverImage } from '../../states/user/user-action';
import { CommonModule } from '@angular/common';
import { PortalService } from '../../services/account/portal.service';

@Component({
  selector: 'app-update-photos',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, InputTextModule, PasswordModule, CalendarModule, DropdownModule, ImageCropUploadComponent],
  templateUrl: './update-photos.component.html',
  styleUrl: './update-photos.component.scss'
})
export class UpdatePhotosComponent implements OnInit{

  currentPortal: string | null = null;

  constructor(private messageService: MessageService, private accountservice: AccountCentreService,
    private authService:AuthService,private store:Store, private portalService: PortalService
  ) { }
  user!: UserStateModel;
  userDetails: UserResponse|null=null;
  profilePhoto: File | Blob | undefined;
  coverPhoto: File | Blob | undefined;
  // profileImage = signal(this.userDetails?.imageUrl);
  // coverImage = signal(this.userDetails?.coverImageUrl);
  profileImage =  '../../../assets/images/avatar1.jpg';
  coverImage = '../../../assets/images/avatar1.jpg';

  private loadUserData(){
    this.store.select(UserSelectors.getUser).pipe(
      switchMap((user)=>{
        if(!user || !user.id){
          return of(null);
        }
        this.user = user;
        return this.authService.getUserByid(user.id);
      })
    ).subscribe({
      next: (response) => {
        if(response != null){
          this.userDetails = response;
          this.profileImage = response.imageUrl ?? '../../../assets/images/avatar1.jpg';
          this.coverImage = response.coverImageUrl ?? '../../../assets/images/avatar1.jpg';
        }
      }
    })
  }

  ngOnInit(): void {
    this.portalService.currentPortal$.subscribe(portal => {
      this.currentPortal = portal;
    });
    this.loadUserData();
  }

  onFileSelection($event: import("ngx-awesome-uploader").FilePreviewModel[], type: string) {
    if ($event.length > 0) {
      if (type === 'profilePhoto') {
        this.profilePhoto = $event[0].file
      } else if (type === 'coverPhoto') {
        this.coverPhoto = $event[0].file
      }
    }
  }

  onFileRemoved($event: import("ngx-awesome-uploader").FilePreviewModel[], type: string) {
    if ($event.length > 0) {
      if (type === 'profilePhoto') {
        this.profilePhoto = undefined;
      } else if (type === 'coverPhoto') {
        this.coverPhoto = undefined;
      }
    }
  }

  onFileHandlingError(message: string, type: string) {
    if (type === 'profilePhoto') {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
    } else if (type === 'coverPhoto') {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
    }
  }

  onSubmit(){
    this.accountservice.updatePhoto({
      profilePhoto: this.profilePhoto instanceof File ? this.profilePhoto : null,
      coverPhoto: this.coverPhoto instanceof File ? this.coverPhoto : null
    }).subscribe({
      next:(response) =>{
        this.store.dispatch(new UpdateProfileCoverImage({
          profileImageUrl: response.profileImageUrl ?? undefined,
          profileImageUrlFormat: response.profileImageFormat ?? undefined
        }))
        this.messageService.add({severity: 'success', summary: 'Success', detail: 'Successfully Updated'})
      }
    })
  }

  onProfileCropped(base64: string) {
    this.profileImage = base64;
    this.profilePhoto = this.dataURLtoFile(base64, 'profile.png');
  }
  
  onCoverCropped(base64: string) {
    this.coverImage = base64;
    this.coverPhoto = this.dataURLtoFile(base64, 'cover.png');
  }
  
  dataURLtoFile(dataUrl: string, filename: string): File {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  }
}
